import { Permissions } from 'Permission';
import { usePermissions } from 'PermissionContext';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useFidesChat } from '../../../context/FidesChatContext';

export let hasPermission: ((permission: Permissions) => boolean) | undefined;

function useFidesChatFromUrl() {
  const location = useLocation();
  const fidesChat = useFidesChat();
  const openTranscript = fidesChat?.openTranscript;
  const openConversation = fidesChat?.openConversation;

  useEffect(() => {
    if (!openTranscript || !openConversation) {
      return;
    }

    const queryParams = new URLSearchParams(location.search);
    const chatMode = queryParams.get('chat');
    const chatId = queryParams.get('chatId');

    if (chatMode === 'transcript' && chatId) {
      openTranscript(chatId);
    } else if (chatMode === 'open' && chatId) {
      openConversation(chatId);
    }
  }, [location.search, location.pathname, openTranscript, openConversation]);
}

export const SetupPermissionInApp: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  hasPermission = usePermissions().hasPermission;
  useFidesChatFromUrl();

  return <>{children}</>;
};

/** Test-only reset for module-level permission bridge state. */
export function resetHasPermissionForTests() {
  hasPermission = undefined;
}
